/** A generic room harvest is not field-specific proof of pricing extraction. */
export const ROOM_HARVEST_STALE_MS = 48 * 60 * 60 * 1000;
export function roomHarvestFreshness(lastHarvested: Date | string | null | undefined, now = Date.now()) {
  const stamp = lastHarvested ? new Date(lastHarvested).getTime() : NaN;
  if (!Number.isFinite(stamp)) return { state: "missing", label: "No harvest recorded" };
  const hours = Math.max(0, Math.floor((now - stamp) / 3_600_000));
  return {
    state: now - stamp > ROOM_HARVEST_STALE_MS ? "stale" : "recent",
    label: `Harvest ${hours < 24 ? `${hours}h` : `${Math.floor(hours / 24)}d`} ago`,
  };
}
